import { Icon, IconName, IconProps } from '../icon/index';
import { Tooltip, TooltipProps } from '../tooltip/index';

type HoverInfoIcon = {
	infoText: TooltipProps['title'];
	iconName?: IconName;
	color?: IconProps['color'];
	fontSize?: IconProps['fontSize'];
};

/**
 * An Icon that provides useful information when hovered. This component should be used for no more than a simple string.
 * More complex overlays should not be rendered inside a Tooltip.
 */
export const HoverInfoIcon = (props: HoverInfoIcon) => {
	return (
		<Tooltip title={props.infoText}>
			<Icon fontSize={props.fontSize ?? undefined} color={props.color ?? undefined} iconName={props.iconName ?? 'Info'} />
		</Tooltip>
	);
};
